import type { AxiosResponse } from 'axios';

let toastSuccess: ((message: string) => void) | null = null;

/**
 * Initialize API helpers with toast function
 * @param {Function} successToast - Toast success function
 */
export function initializeApiHelpers(successToast: (message: string) => void) {
  toastSuccess = successToast;
}

/**
 * Wrapper for API calls that shows success notifications
 * @param {Promise<AxiosResponse>} apiCall - API call promise
 * @param {string} successMessage - Success message to show
 * @returns {Promise<AxiosResponse>} API response
 */
export async function withSuccessToast<T = any>(
  apiCall: Promise<AxiosResponse<T>>,
  successMessage: string
): Promise<AxiosResponse<T>> {
  const response = await apiCall;

  if (toastSuccess) {
    toastSuccess(successMessage);
  }

  return response;
}

/**
 * Success messages for common operations
 */
export const successMessages = {
  // Story operations
  storyCreated: 'Story created successfully!',
  storyUpdated: 'Story updated successfully!',
  storyDeleted: 'Story deleted successfully!',
  storyPublished: 'Story published successfully!',
  storyUnpublished: 'Story unpublished successfully!',

  // Slide operations
  slideCreated: 'Slide added successfully!',
  slideUpdated: 'Slide updated successfully!',
  slideDeleted: 'Slide deleted successfully!',
  slidesReordered: 'Slides reordered successfully!',

  // Settings operations
  categoryCreated: 'Category created successfully!',
  categoryUpdated: 'Category updated successfully!',
  categoryDeleted: 'Category deleted successfully!',

  subcategoryCreated: 'Subcategory created successfully!',
  subcategoryUpdated: 'Subcategory updated successfully!',
  subcategoryDeleted: 'Subcategory deleted successfully!',

  tagCreated: 'Tag created successfully!',
  tagUpdated: 'Tag updated successfully!',
  tagDeleted: 'Tag deleted successfully!',

  // Auth operations
  profileUpdated: 'Profile updated successfully!',
  passwordChanged: 'Password changed successfully!',

  // General
  changesSaved: 'Changes saved successfully!',
  operationCompleted: 'Operation completed successfully!',
};